import { render, staticRenderFns } from "./oilsListNow.vue?vue&type=template&id=72b5a1e3&scoped=true"
import script from "./oilsListNow.vue?vue&type=script&lang=js"
export * from "./oilsListNow.vue?vue&type=script&lang=js"
import style0 from "./oilsListNow.vue?vue&type=style&index=0&id=72b5a1e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5a1e3",
  null
  
)

export default component.exports